import Swal from 'sweetalert2';

import '../assets/Styles/alert.css';
import store from '../store/index';

let cerrandoSesion = false;

export const alertErrorRequest = async (msg, timer = 0) => {
  return await printAlert({
    title: '¡Error de solicitud!',
    msg: `<span style="font-family:Roboto;">${msg}</span>`,
    icon: 'warning',
    color: COLORS.warning,
    timer,
  });
};

export function alertSuccessResponse(response) {
  const message = response?.data?.message ?? null;

  if (response?.status) {
    return alertResponse({
      statusCode: response.status,
      message,
      error: null,
    });
  }
}

export async function alertErrorResponse(response) {
  if (await validarSesionExpirada(response)) {
    return;
  }

  if (!response?.statusCode) {
    response.statusCode = 500;
  }
  return alertResponse(response);
}

async function alertResponse(response) {
  const { statusCode, message, error } = response;
  let title = '¡Error!';
  let color = 'error';
  let icon = COLORS.error;

  const msg = message || MESSAGES_HTTP[statusCode] || error;

  if (statusCode >= 200 && statusCode < 300) {
    title = '¡Éxito!';
    icon = 'success';
    color = COLORS.success;
  } else if (statusCode >= 400 && statusCode < 500) {
    title = '¡Error de solicitud!';
    icon = 'warning';
    color = COLORS.warning;
  } else if (statusCode >= 500) {
    title = '¡Error!';
    icon = 'error';
    color = COLORS.error;
  }
  return await printAlert({ icon, title, msg, color });
}

const validarSesionExpirada = async response => {
  if (cerrandoSesion) return true;

  if (response?.statusCode === 401) {
    cerrandoSesion = true;

    await printAlert({
      title: '¡Sin cabecera de autenticación!',
      msg: 'Vuelve a iniciar sesión',
      icon: 'warning',
      color: COLORS.warning,
    });

    await store.dispatch('salir');
    cerrandoSesion = false;
    return true;
  }

  return false;
};

async function printAlert({ icon, title, msg, color }) {
  return await Swal.fire({
    icon,
    title,
    html: msg,
    confirmButtonColor: color,
    iconColor: color,
  });
}

const COLORS = {
  error: '#cf3832',
  success: '#44af87',
  warning: '#f2bd06',
};

const MESSAGES_HTTP = {
  200: 'OK',
  201: 'Creado correctamente',
  204: 'Actualizado correctamente',
  400: 'Solicitud incorrecta',
  401: 'No autorizado',
  403: 'Prohibido',
  404: 'Registro no encontrado',
  409: 'Conflicto',
  500: 'Error interno del servidor',
};
